
import React, { Component, PureComponent } from 'react'
import ReactDOM from 'react-dom'
import CONSTANTS from '../../../constants'
import ConfirmationDialog from '../../Breadcrumb/ConfirmationDialog'
import { pushEventToGTM } from '../../../helpers/trackerManager'
import { slugify } from '../../../helpers/functions'
import {
  Redirect,
  Switch
} from 'react-router-dom'
import { connect } from 'react-redux'
import { setDialogConfirmationStepChange, CurrentStepSetAction } from '../../../actions/action'

import Icon from '../../buttons/Icon'
import EditButton from '../../buttons/EditButton'
const mapStateToProps = state => state
const mapDispatchToProps = { setDialogConfirmationStepChange, CurrentStepSetAction }

class TimeSummary extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showDialog: false,
      redirectToLocation: false
    }
    this.confirmAndRedirect = this.confirmAndRedirect.bind(this)
  }

  confirmAndRedirect(isRedirect) {
    if (isRedirect) {
      this.setState({ redirectToLocation: true })
      // this.props.CurrentStepSetAction(2);
    }
    // Reset id of visible dialog step change.
    this.props.setDialogConfirmationStepChange('')
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.redirectToLocation) { this.setState({ redirectToLocation: false }) }
  }

  render() {
    const { geoID } = this.props.store.dealer
    return (
      <div className='dateDetails carSummaryBlock'>

<div className="middleContainer">
    <div className="dateContainer">
      <div className="dateTitle">
        <span className="iconCalendarMobile"></span>{" "}
        {CONSTANTS.LABELS.header_modification_date}
      </div>
      <div className="dateContent">{this.props.date ? this.props.date : undefined}</div>
    </div>
    <div className="clockContainer">
      <div className="clockTitle">
        <span className="iconClockMobile"></span>{" "}
        {CONSTANTS.LABELS.header_modification_time}
      </div>
      <div className="clockContent">{this.props.time ? this.props.time : undefined}</div>
    </div>
  </div>

      
        {this.props.store.visibaleDialogId == 'TimeChange' && <ConfirmationDialog isConfirmedDialog={(e) => {
          this.confirmAndRedirect(e)
        }}
        />}
        {this.state.redirectToLocation && <Switch>
          <Redirect
            push
            to={{ pathname: String(CONSTANTS.SITE_ROUTS.SOLODEALERPAGE + slugify(this.props.store.dealer.city) + '/' + slugify(this.props.store.dealer.name) + '/' + this.props.store.dealer.geoID) }}
          />
        </Switch>}
      </div>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(TimeSummary)
